export type CurrencyCode = 'EUR' | 'GBP' | 'USD';

export interface CurrencyConfig {
  code: CurrencyCode;
  symbol: string;
  price: number;
  originalPrice: number;
  amountCents: number;
  label: string;
  originalLabel: string;
}

const EUROZONE_COUNTRIES = new Set([
  'AT', 'BE', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR',
  'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PT', 'SI', 'SK',
  'AD', 'MC', 'SM', 'VA',
]);

const GBP_COUNTRIES = new Set(['GB', 'GG', 'JE', 'IM']);

const CURRENCY_CONFIGS: Record<CurrencyCode, CurrencyConfig> = {
  EUR: { code: 'EUR', symbol: '€', price: 5, originalPrice: 10, amountCents: 500, label: '€5', originalLabel: '€10' },
  GBP: { code: 'GBP', symbol: '£', price: 5, originalPrice: 10, amountCents: 500, label: '£5', originalLabel: '£10' },
  USD: { code: 'USD', symbol: '$', price: 5, originalPrice: 10, amountCents: 500, label: '$5', originalLabel: '$10' },
};

export function countryToCurrency(countryCode: string): CurrencyCode {
  const upper = countryCode.toUpperCase();
  if (EUROZONE_COUNTRIES.has(upper)) return 'EUR';
  if (GBP_COUNTRIES.has(upper)) return 'GBP';
  return 'USD';
}

export function getCurrencyConfig(currency: CurrencyCode): CurrencyConfig {
  return CURRENCY_CONFIGS[currency];
}

export function formatPrice(currency: CurrencyCode, amount: number): string {
  const { symbol } = CURRENCY_CONFIGS[currency];
  return `${symbol}${amount}`;
}

export const ALL_CURRENCIES: CurrencyCode[] = ['EUR', 'GBP', 'USD'];
